import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=056d97b3&scoped=true&"
import script from "./DateSelect.vue?vue&type=script&lang=js&"
export * from "./DateSelect.vue?vue&type=script&lang=js&"
import style0 from "./DateSelect.vue?vue&type=style&index=0&id=056d97b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d97b3",
  null
  
)

export default component.exports